import { render, staticRenderFns } from "./ResetPasswordForm.vue?vue&type=template&id=771fa8e2&"
import script from "./ResetPasswordForm.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JVolke\\Documents\\plentyDevTool\\38722\\18\\KrauseSohn\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('771fa8e2')) {
      api.createRecord('771fa8e2', component.options)
    } else {
      api.reload('771fa8e2', component.options)
    }
    module.hot.accept("./ResetPasswordForm.vue?vue&type=template&id=771fa8e2&", function () {
      api.rerender('771fa8e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/customer/ResetPasswordForm.vue"
export default component.exports